import { AssistantAdapter, HostDocumentModel } from "../../../platform";
import { InferenceRequest, Message } from "../types/inference-request";

// Assembles the inference request. Everything host-specific -- the tool surface, and
// the system prompt that explains the host's document model -- comes off the adapter,
// so this function is the same in Word, Excel and PowerPoint.
//
// The document state is re-sent whole on every turn rather than accumulated in the
// history: the user can edit underneath us between messages, so anything older is a
// lie. The system prompt says as much, and warns the model off stale segment IDs.
//
// It goes after the history, beside the prompt it answers. Placed before the history
// it ended up buried under every earlier turn's tool results, and models told the
// user the document had not been sent.

export const buildChatMessages = async (
  prompt: string,
  conversationHistory: Message[] = [],
  docModel: HostDocumentModel,
  assistant: AssistantAdapter
): Promise<InferenceRequest> => {
  return {
    tools: assistant.toolSchemas,
    messages: [
      {
        role: "system",
        content: assistant.systemPrompt,
      },
      ...conversationHistory,
      {
        role: "user",
        content: `Current document state:\n${JSON.stringify(docModel)}`,
      },
      {
        role: "user",
        content: prompt,
      },
    ],
  };
};
